import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, renderList as _renderList, withCtx as _withCtx, createTextVNode as _createTextVNode, mergeProps as _mergeProps, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-10003500")
const _hoisted_1 = { class: "page--limited card" }
const _hoisted_2 = { class: "p-d-flex p-ai-center" }
const _hoisted_3 = { class: "p-d-flex p-ai-center" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "p-d-flex p-ai-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-paperclip" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Load ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Dump ")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-calendar" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-dollar" }, null, -1)
const _hoisted_12 = {
  key: 1,
  class: "p-formgroup"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-paperclip" }, null, -1)
const _hoisted_14 = { class: "p-grid" }
const _hoisted_15 = { class: "p-col" }
const _hoisted_16 = { class: "p-col" }
const _hoisted_17 = { class: "p-col" }
const _hoisted_18 = { class: "p-col" }
const _hoisted_19 = { class: "p-col" }
const _hoisted_20 = { class: "p-col" }
const _hoisted_21 = { class: "p-grid" }
const _hoisted_22 = { class: "p-col" }
const _hoisted_23 = { class: "p-col" }
const _hoisted_24 = { class: "p-grid" }
const _hoisted_25 = { class: "p-col" }
const _hoisted_26 = { class: "p-col" }
const _hoisted_27 = { class: "p-col" }
const _hoisted_28 = { class: "p-col" }
const _hoisted_29 = { class: "p-col" }
const _hoisted_30 = { class: "p-col" }
const _hoisted_31 = { class: "p-grid" }
const _hoisted_32 = { class: "p-col" }
const _hoisted_33 = { class: "p-col" }
const _hoisted_34 = { class: "p-col" }
const _hoisted_35 = { class: "p-col" }
const _hoisted_36 = { class: "p-col" }
const _hoisted_37 = { class: "p-col" }
const _hoisted_38 = { class: "p-grid" }
const _hoisted_39 = { class: "p-col" }
const _hoisted_40 = { class: "p-col" }
const _hoisted_41 = { class: "p-col" }
const _hoisted_42 = { class: "p-col" }
const _hoisted_43 = { class: "p-col" }
const _hoisted_44 = { class: "p-col" }
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" Load ")
const _hoisted_46 = { class: "p-grid" }
const _hoisted_47 = { class: "p-col" }
const _hoisted_48 = { class: "p-col" }
const _hoisted_49 = { class: "p-col" }
const _hoisted_50 = { class: "p-col" }
const _hoisted_51 = { class: "p-col" }
const _hoisted_52 = { class: "p-col" }
const _hoisted_53 = { class: "p-grid" }
const _hoisted_54 = { class: "p-col" }
const _hoisted_55 = { class: "p-col" }
const _hoisted_56 = { class: "p-col" }
const _hoisted_57 = { class: "p-col" }
const _hoisted_58 = { class: "p-col" }
const _hoisted_59 = { class: "p-col" }
const _hoisted_60 = { class: "p-grid" }
const _hoisted_61 = { class: "p-col-2" }
const _hoisted_62 = { class: "p-col-10" }
const _hoisted_63 = /*#__PURE__*/_createTextVNode(" Dump ")
const _hoisted_64 = { class: "p-grid" }
const _hoisted_65 = { class: "p-col" }
const _hoisted_66 = { class: "p-col" }
const _hoisted_67 = { class: "p-col" }
const _hoisted_68 = { class: "p-col" }
const _hoisted_69 = { class: "p-col" }
const _hoisted_70 = { class: "p-col" }
const _hoisted_71 = { class: "p-grid" }
const _hoisted_72 = { class: "p-col" }
const _hoisted_73 = { class: "p-col" }
const _hoisted_74 = { class: "p-col" }
const _hoisted_75 = { class: "p-col" }
const _hoisted_76 = { class: "p-col" }
const _hoisted_77 = { class: "p-col" }
const _hoisted_78 = { class: "p-grid" }
const _hoisted_79 = { class: "p-col-2" }
const _hoisted_80 = { class: "p-col-2" }
const _hoisted_81 = { class: "p-col-2" }
const _hoisted_82 = { class: "p-col-6" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-calendar" }, null, -1)
const _hoisted_84 = { class: "p-grid" }
const _hoisted_85 = { class: "p-col" }
const _hoisted_86 = { class: "p-col" }
const _hoisted_87 = { class: "p-col" }
const _hoisted_88 = { class: "p-col" }
const _hoisted_89 = { class: "p-col" }
const _hoisted_90 = { class: "p-col" }
const _hoisted_91 = { class: "p-grid" }
const _hoisted_92 = { class: "p-col-2" }
const _hoisted_93 = { class: "p-col-2" }
const _hoisted_94 = { class: "p-col-2" }
const _hoisted_95 = { class: "p-col-6" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-dollar" }, null, -1)
const _hoisted_97 = { class: "p-grid" }
const _hoisted_98 = { class: "p-col" }
const _hoisted_99 = { class: "p-col" }
const _hoisted_100 = { class: "p-col" }
const _hoisted_101 = { class: "p-col" }
const _hoisted_102 = {
  key: 0,
  class: "p-col"
}
const _hoisted_103 = {
  key: 1,
  class: "p-col"
}
const _hoisted_104 = {
  key: 2,
  class: "p-col"
}
const _hoisted_105 = {
  key: 3,
  class: "p-col"
}
const _hoisted_106 = {
  key: 4,
  class: "p-col"
}
const _hoisted_107 = {
  key: 5,
  class: "p-col"
}
const _hoisted_108 = { class: "p-grid" }
const _hoisted_109 = { class: "p-col" }
const _hoisted_110 = { class: "p-col" }
const _hoisted_111 = { class: "p-col" }
const _hoisted_112 = { class: "p-col" }
const _hoisted_113 = { class: "p-col" }
const _hoisted_114 = { class: "p-col" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackButton = _resolveComponent("BackButton")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Fieldset = _resolveComponent("Fieldset")!
  const _component_Chip = _resolveComponent("Chip")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DateFormatted = _resolveComponent("DateFormatted")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_BackButton, { to: _ctx.backRoute }, null, 8, ["to"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isNew)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_4, _toDisplayString(_ctx.$t('shift.title_new')), 1))
          : (_openBlock(), _createElementBlock("h1", _hoisted_5, _toDisplayString(_ctx.$t('shift.title_detail')), 1))
      ]),
      _createElementVNode("div", _hoisted_6, [
        (!_ctx.requestPending)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.shift.status !== _ctx.appShiftStatusEnum.APPROVED)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    label: "Approve and prefill WRS",
                    onClick: _ctx.onApprove
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.shift.status !== _ctx.appShiftStatusEnum.REJECTED && _ctx.shift.status !== _ctx.appShiftStatusEnum.APPROVED)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 1,
                    class: "p-button-warning p-ml-2",
                    label: "Reject",
                    onClick: _ctx.onReject
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_Button, {
                class: "p-button-danger p-ml-2",
                label: "Delete",
                onClick: _ctx.onDelete
              }, null, 8, ["onClick"])
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.requestPending)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_Fieldset, null, {
            legend: _withCtx(() => [
              _hoisted_7
            ]),
            default: _withCtx(() => [
              _createElementVNode("section", null, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (g) => {
                  return _createElementVNode("div", {
                    class: "p-grid",
                    key: `skeleton_grid${g}`
                  }, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (a) => {
                      return _createElementVNode("div", {
                        class: "p-col",
                        key: `skeleton${a}`
                      }, [
                        _createVNode(_component_Skeleton, { height: "1.5rem" })
                      ])
                    }), 64))
                  ])
                }), 64))
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Fieldset, { class: "p-mt-3" }, {
            legend: _withCtx(() => [
              _hoisted_8
            ]),
            default: _withCtx(() => [
              _createElementVNode("section", null, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (g) => {
                  return _createElementVNode("div", {
                    class: "p-grid",
                    key: `skeleton_grid${g}`
                  }, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (a) => {
                      return _createElementVNode("div", {
                        class: "p-col",
                        key: `skeleton${a}`
                      }, [
                        _createVNode(_component_Skeleton, { height: "1.5rem" })
                      ])
                    }), 64))
                  ])
                }), 64))
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Fieldset, { class: "p-mt-3" }, {
            legend: _withCtx(() => [
              _hoisted_9
            ]),
            default: _withCtx(() => [
              _createElementVNode("section", null, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (g) => {
                  return _createElementVNode("div", {
                    class: "p-grid",
                    key: `skeleton_grid${g}`
                  }, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (a) => {
                      return _createElementVNode("div", {
                        class: "p-col",
                        key: `skeleton${a}`
                      }, [
                        _createVNode(_component_Skeleton, { height: "1.5rem" })
                      ])
                    }), 64))
                  ])
                }), 64))
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Fieldset, { class: "p-mt-3" }, {
            legend: _withCtx(() => [
              _hoisted_10
            ]),
            default: _withCtx(() => [
              _createElementVNode("section", null, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (g) => {
                  return _createElementVNode("div", {
                    class: "p-grid",
                    key: `skeleton_grid${g}`
                  }, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (a) => {
                      return _createElementVNode("div", {
                        class: "p-col",
                        key: `skeleton${a}`
                      }, [
                        _createVNode(_component_Skeleton, { height: "1.5rem" })
                      ])
                    }), 64))
                  ])
                }), 64))
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Fieldset, { class: "p-mt-3" }, {
            legend: _withCtx(() => [
              _hoisted_11
            ]),
            default: _withCtx(() => [
              _createElementVNode("section", null, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (g) => {
                  return _createElementVNode("div", {
                    class: "p-grid",
                    key: `skeleton_grid${g}`
                  }, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (a) => {
                      return _createElementVNode("div", {
                        class: "p-col",
                        key: `skeleton${a}`
                      }, [
                        _createVNode(_component_Skeleton, { height: "1.5rem" })
                      ])
                    }), 64))
                  ])
                }), 64))
              ])
            ]),
            _: 1
          })
        ], 64))
      : (_openBlock(), _createElementBlock("form", _hoisted_12, [
          _createVNode(_component_Fieldset, null, {
            legend: _withCtx(() => [
              _hoisted_13
            ]),
            default: _withCtx(() => [
              _createElementVNode("section", null, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('app_shift.status')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_Chip, _mergeProps({
                      label: _ctx.$t('app_shift.statuses.' + _ctx.appShiftStatusEnum[_ctx.shift.status]),
                      class: ["p-text-nowrap custom-chip", _ctx.statusBadgeColor]
                    }, _ctx.$attrs), null, 16, ["label", "class"])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('app_shift.user')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_router_link, {
                      to: {
                name: _ctx.userRoute,
                params: {
                  userId: _ctx.shift.user.id
                }
              }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.shift.user.fullname), 1)
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('app_shift.created_at')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_DateFormatted, {
                      date: _ctx.createdAt,
                      format: "YYYY-MM-DD hh:mm A"
                    }, null, 8, ["date"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  (_ctx.shift.shift)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("span", null, [
                            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('app_shift.created_shift')), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _createVNode(_component_router_link, {
                            to: {
                   name: _ctx.shiftsRoutesEnum.SHIFTS_DETAIL,
                   params: { shiftId: _ctx.shift.shift.id }}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.shift.shift.code), 1)
                            ]),
                            _: 1
                          }, 8, ["to"])
                        ])
                      ], 64))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: _normalizeClass({ 'p-col': _ctx.shift.shift, 'p-col-2': !_ctx.shift.shift })
                  }, [
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('app_shift.job_site')), 1)
                    ])
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass({ 'p-col': _ctx.shift.shift, 'p-col-2': !_ctx.shift.shift })
                  }, _toDisplayString(_ctx.shift.job_site), 3),
                  _createElementVNode("div", {
                    class: _normalizeClass({ 'p-col': _ctx.shift.shift, 'p-col-2': !_ctx.shift.shift })
                  }, [
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('app_shift.cost_code')), 1)
                    ])
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass({ 'p-col': _ctx.shift.shift, 'p-col-2': !_ctx.shift.shift })
                  }, _toDisplayString(_ctx.shift.cost_code), 3)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('app_shift.shift_reference')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.shift.shift_reference), 1),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('app_shift.poc_name')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.shift.poc_name), 1),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('app_shift.email')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.shift.email), 1)
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('app_shift.phone')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.shift.phone), 1),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('app_shift.material_state')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.shift.material_state.name), 1),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('app_shift.material')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.shift.material?.name), 1)
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('app_shift.material_other')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.shift.material_other), 1),
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('app_shift.load_type')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.shift.load_type?.name), 1),
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('app_shift.load_type_other')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.shift.load_type_other), 1)
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Fieldset, { class: "p-mt-3" }, {
            legend: _withCtx(() => [
              _hoisted_45
            ]),
            default: _withCtx(() => [
              _createElementVNode("section", null, [
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('app_shift.is_use_load_w3')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.shift.is_use_load_w3 ? 'Yes' : 'No'), 1),
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('app_shift.w3load')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.shift.w3load), 1),
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('app_shift.load_driver_note')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.shift.load_driver_note), 1)
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('app_shift.load_city')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.shift.load_city), 1),
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('app_shift.load_address')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.shift.load_address), 1),
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('app_shift.load_zip')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.shift.load_zip), 1)
                ]),
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('app_shift.load_state')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.shift.load_state?.name), 1)
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Fieldset, { class: "p-mt-3" }, {
            legend: _withCtx(() => [
              _hoisted_63
            ]),
            default: _withCtx(() => [
              _createElementVNode("section", null, [
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("div", _hoisted_65, [
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('app_shift.is_dump_same_load_site')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_66, _toDisplayString(_ctx.shift.is_dump_same_load_site ? 'Yes': 'No'), 1),
                  _createElementVNode("div", _hoisted_67, [
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('app_shift.is_use_dump_w3')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.shift.is_use_dump_w3 ? 'Yes': 'No'), 1),
                  _createElementVNode("div", _hoisted_69, [
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('app_shift.w3dump')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_70, _toDisplayString(_ctx.shift.w3dump), 1)
                ]),
                _createElementVNode("div", _hoisted_71, [
                  _createElementVNode("div", _hoisted_72, [
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('app_shift.dump_driver_note')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_73, _toDisplayString(_ctx.shift.dump_driver_note), 1),
                  _createElementVNode("div", _hoisted_74, [
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('app_shift.dump_city')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_75, _toDisplayString(_ctx.shift.dump_city), 1),
                  _createElementVNode("div", _hoisted_76, [
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('app_shift.dump_address')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_77, _toDisplayString(_ctx.shift.dump_address), 1)
                ]),
                _createElementVNode("div", _hoisted_78, [
                  _createElementVNode("div", _hoisted_79, [
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('app_shift.dump_zip')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_80, _toDisplayString(_ctx.shift.dump_zip), 1),
                  _createElementVNode("div", _hoisted_81, [
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('app_shift.dump_state')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_82, _toDisplayString(_ctx.shift.dump_state?.name), 1)
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Fieldset, { class: "p-mt-3" }, {
            legend: _withCtx(() => [
              _hoisted_83
            ]),
            default: _withCtx(() => [
              _createElementVNode("section", null, [
                _createElementVNode("div", _hoisted_84, [
                  _createElementVNode("div", _hoisted_85, [
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('app_shift.date')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_86, _toDisplayString(_ctx.shift.date), 1),
                  _createElementVNode("div", _hoisted_87, [
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('app_shift.start_datetime')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_88, _toDisplayString(_ctx.shift.startDateTime), 1),
                  _createElementVNode("div", _hoisted_89, [
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('app_shift.end_datetime')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_90, _toDisplayString(_ctx.shift.endDateTime), 1)
                ]),
                _createElementVNode("div", _hoisted_91, [
                  _createElementVNode("div", _hoisted_92, [
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('app_shift.zone_name')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_93, _toDisplayString(_ctx.shift.zone_name), 1),
                  _createElementVNode("div", _hoisted_94, [
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('app_shift.staggered_start_mins')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_95, _toDisplayString(_ctx.shift.staggered_start_mins), 1)
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Fieldset, { class: "p-mt-3" }, {
            legend: _withCtx(() => [
              _hoisted_96
            ]),
            default: _withCtx(() => [
              _createElementVNode("section", null, [
                _createElementVNode("div", _hoisted_97, [
                  _createElementVNode("div", _hoisted_98, [
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('app_shift.contract_name')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_99, _toDisplayString(_ctx.shift.contract_name), 1),
                  _createElementVNode("div", _hoisted_100, [
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('app_shift.payment_type')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_101, _toDisplayString(_ctx.$t('app_shift.payment_types.' + _ctx.paymentTypeEnum[_ctx.shift.payment_type])), 1),
                  (_ctx.canSeePriceHour)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                        _createElementVNode("span", null, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('app_shift.price_hour')), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.canSeePriceHour)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_103, _toDisplayString(_ctx.shift.price_hour), 1))
                    : _createCommentVNode("", true),
                  (_ctx.canSeePriceCycle)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                        _createElementVNode("span", null, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('app_shift.price_cycle')), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.canSeePriceCycle)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_105, _toDisplayString(_ctx.shift.price_cycle), 1))
                    : _createCommentVNode("", true),
                  (_ctx.canSeePriceTon)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                        _createElementVNode("span", null, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('app_shift.price_ton')), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.canSeePriceTon)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_107, _toDisplayString(_ctx.shift.price_ton), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_108, [
                  _createElementVNode("div", _hoisted_109, [
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('app_shift.trucks_min')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_110, _toDisplayString(_ctx.shift.trucks_min), 1),
                  _createElementVNode("div", _hoisted_111, [
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('app_shift.trucks_max')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_112, _toDisplayString(_ctx.shift.trucks_max), 1),
                  _createElementVNode("div", _hoisted_113, [
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('app_shift.drivers_note')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_114, _toDisplayString(_ctx.shift.drivers_note), 1)
                ])
              ])
            ]),
            _: 1
          })
        ]))
  ]))
}